import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Setup-instruction building blocks (channels, Claude Code / MCP, …). */

export function Steps({ children }: { children: ReactNode }) {
  return <ol className="ml-4 list-decimal space-y-1 text-sm text-fg-2">{children}</ol>;
}

/** Collapsible setup instructions; `open` for cards that can't be used until the steps are done. */
export function Guide({ title, open, children }: { title: string; open?: boolean; children: ReactNode }) {
  return (
    <details open={open} className="group rounded-md border border-border bg-panel-2/50">
      <summary className="flex cursor-pointer list-none items-center gap-1.5 px-3 py-2 text-xs font-medium text-fg-2 select-none hover:text-fg [&::-webkit-details-marker]:hidden">
        <span aria-hidden className="text-muted transition-transform group-open:rotate-90">
          ›
        </span>
        {title}
      </summary>
      <div className="flex flex-col gap-2 px-3 pb-3">{children}</div>
    </details>
  );
}

export function Code({ children }: { children: ReactNode }) {
  return <code className="font-mono text-fg">{children}</code>;
}

export function Ext({ href, children }: { href: string; children: ReactNode }) {
  return (
    <a href={href} target="_blank" rel="noreferrer noopener" className="text-accent hover:underline">
      {children} ↗
    </a>
  );
}

export function Note({ children }: { children: ReactNode }) {
  return <p className="text-xs text-muted">{children}</p>;
}

export function Pre({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <pre
      className={cn(
        'overflow-x-auto rounded-md border border-border bg-panel p-2 font-mono text-xs whitespace-pre text-fg',
        className,
      )}
    >
      {children}
    </pre>
  );
}
